export const environment = {
  production: false,
  WEATHER_API_KEY: '1a39c9738cb48d1d40cc282fc9d43b4a',
};
